import { render, staticRenderFns } from "./AdditionAll.vue?vue&type=template&id=2a68cd5a&"
import script from "./AdditionAll.vue?vue&type=script&lang=ts&"
export * from "./AdditionAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports